import { EpimsBaseEntityDto } from './epim-base.dto';
export class FacilityAssetDto extends EpimsBaseEntityDto {

    FacilityAssetId: string;

    FacilityAssetName: string; 
    
    FacilityCode: string;
    length: number;
    Version: number;

}